import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useCookies } from 'react-cookie'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { encodeKey } from '_core/utils/storage'
import { currencyActions, currencySelectors } from '_core/store/Currency'
import { CurrencySwitchView } from './CurrencySwitchView'

const mapState = state => ({
  currencies: currencySelectors.getCurrencyList(state),
  currencyId: currencySelectors.getCurrentCurrencyId(state),
})

const mapDispatch = {
  changeCurrency: currencyActions.changeCurrency,
}

const RawCurrencySwitch = props => {
  const {
    className,
    tooltip,
    inMenu,
    hasSigns,
    currencies,
    currencyId,
    changeCurrency,
  } = props

  const {
    config: { COOKIES_TIME, COOKIES_KEY },
  } = useGlobal()

  const [isLoading, setIsLoading] = useState(false)
  const [, setCookie] = useCookies([encodeKey(COOKIES_KEY.CURRENCY)])

  const onChange = newCode => {
    // Get new currency id by it's ISO code
    const newId = +currencies.find(
      currency => currency.code === newCode.toLowerCase()
    ).id

    setIsLoading(true)

    // Change app currency in store
    changeCurrency(newId)

    // Change app currency cookie
    updateCookie(newId)

    setIsLoading(false)
  }

  const updateCookie = newId => {
    const stamp = Date.now() + COOKIES_TIME

    setCookie(encodeKey(COOKIES_KEY.CURRENCY), newId, {
      path: '/',
      expires: new Date(stamp),
    })
  }

  return (
    <CurrencySwitchView
      className={className}
      tooltip={tooltip}
      currencies={currencies}
      currencyId={currencyId}
      isLoading={isLoading}
      onChange={onChange}
      hasSigns={hasSigns}
      inMenu={inMenu}
    />
  )
}

RawCurrencySwitch.defaultProps = {}

RawCurrencySwitch.propTypes = {
  // self props
  className: PropTypes.string,
  tooltip: PropTypes.string,
  hasSigns: PropTypes.bool,
  inMenu: PropTypes.bool,

  // `redux-connect` HOC props
  currencies: PropTypes.arrayOf(PropTypes.object).isRequired,
  currencyId: PropTypes.number.isRequired,
  changeCurrency: PropTypes.func.isRequired,
}

export const CurrencySwitch = connect(mapState, mapDispatch)(RawCurrencySwitch)
